import React from 'react';
import SelectAccountView from 'screens/SelectAccount/components/View';
import { Account } from 'types/Account';

type SelectAccountProps = {
  show: boolean,
  selectAccount: ( accountId: string ) => void
  accounts: Account[],
  userRole?: string,
};

function SelectAccount( {
  show, accounts, userRole, selectAccount,
}: SelectAccountProps ) {
  return (
    <SelectAccountView
      show={show}
      accounts={accounts}
      role={userRole}
      onSelectAccount={selectAccount}
    />
  );
}

export default SelectAccount;
